import { DateTime } from 'luxon';
import { convertToISODateTime } from '../../../../util/util';

export function usePrivacytoString(detail, lang, logo, width) {
    const cctvPolicy = detail?.cctvPolicy;
    const cctvIntroductionLawfulBasis = detail?.cctvIntroductionLawfulBasis;
    const cctvPersonalDataCollect = detail?.cctvPersonalDataCollect;
    const cctvReasonCollectedData = detail?.cctvReasonCollectedData;
    const cctvTransferPersonalData = detail?.cctvTransferPersonalData;
    const cctvRetainPersonalData = detail?.cctvRetainPersonalData;
    const cctvDataSubjectRight = detail?.cctvDataSubjectRight;
    const cctvPolicyChange = detail?.cctvPolicyChange;

    const effectiveDate = convertToISODateTime(cctvPolicy?.effectiveDate);

    let date = '';
    if (cctvPolicy?.updateDate) {
        const split = cctvPolicy?.updateDate.split('/');
        const year = split[2].split(' ');
        date = `_${split[0]}-${split[1]}-${year[0]}_`;
    }

    const body = `
    <body style="word-break: break-word;">
        <center>
        ${
            logo
                ? `<img
            width=${width} height="100"
        style="object-fit: cover;"
        src=${logo}
        alt="logo "/>`
                : ''
        }</center>
        <center>
            <h3>
                ${
                    lang === 'TH'
                        ? cctvPolicy?.cctvPolicyNameTh
                        : cctvPolicy?.cctvPolicyNameEn
                }
            </h3>
        </center>
        ${
            cctvIntroductionLawfulBasis?.cctvIntroductionIsDisplay
                ? `<p className="text-left">
                    ${
                        lang === 'TH'
                            ? cctvIntroductionLawfulBasis?.cctvIntroductionContentTh ||
                              '-'
                            : cctvIntroductionLawfulBasis?.cctvIntroductionContentEn ||
                              '-'
                    }
                </p>`
                : ''
        }
        ${
            cctvIntroductionLawfulBasis?.cctvLawfulBasisIsDisplay
                ? `<h4>
                ${
                    lang === 'TH'
                        ? cctvIntroductionLawfulBasis?.cctvLawfulBasisTitleTh
                        : cctvIntroductionLawfulBasis?.cctvLawfulBasisTitleEn
                }
            </h4>
            <p className="text-left">
                 ${
                     lang === 'TH'
                         ? cctvIntroductionLawfulBasis?.cctvLawfulBasisContentTh ||
                           '-'
                         : cctvIntroductionLawfulBasis?.cctvLawfulBasisContentEn ||
                           '-'
                 }
             </p>`
                : ''
        }
        ${
            cctvPersonalDataCollect?.cctvPersonalDataIsDisplay
                ? `<h4>
                ${
                    lang === 'TH'
                        ? cctvPersonalDataCollect?.cctvPersonalDataTitleTh
                        : cctvPersonalDataCollect?.cctvPersonalDataTitleEn
                }
            </h4>
            <p className="text-left">
                 ${
                     lang === 'TH'
                         ? cctvPersonalDataCollect?.cctvPersonalDataContentTh ||
                           '-'
                         : cctvPersonalDataCollect?.cctvPersonalDataContentEn ||
                           '-'
                 }
             </p>`
                : ''
        }
        ${
            cctvPersonalDataCollect?.cctvSourceIsDisplay
                ? `<h4>
                ${
                    lang === 'TH'
                        ? cctvPersonalDataCollect?.cctvSourceTitleTh
                        : cctvPersonalDataCollect?.cctvSourceTitleEn
                }
            </h4>
            <p className="text-left">
                 ${
                     lang === 'TH'
                         ? cctvPersonalDataCollect?.cctvSourceContentTh || '-'
                         : cctvPersonalDataCollect?.cctvSourceContentEn || '-'
                 }
             </p>`
                : ''
        }
        ${
            cctvReasonCollectedData?.cctvPurposeIsDisplay
                ? `<h4>
                ${
                    lang === 'TH'
                        ? cctvReasonCollectedData?.cctvPurposeTitleTh
                        : cctvReasonCollectedData?.cctvPurposeTitleEn
                }
            </h4>
            <p className="text-left">
                 ${
                     lang === 'TH'
                         ? cctvReasonCollectedData?.cctvPurposeContentTh || '-'
                         : cctvReasonCollectedData?.cctvPurposeContentEn || '-'
                 }
             </p>`
                : ''
        }
        ${
            cctvTransferPersonalData?.cctvDisclosureIsDisplay
                ? `<h4>
                ${
                    lang === 'TH'
                        ? cctvTransferPersonalData?.cctvDisclosureTitleTh
                        : cctvTransferPersonalData?.cctvDisclosureTitleEn
                }
            </h4>
            <p className="text-left">
                 ${
                     lang === 'TH'
                         ? cctvTransferPersonalData?.cctvDisclosureContentTh ||
                           '-'
                         : cctvTransferPersonalData?.cctvDisclosureContentEn ||
                           '-'
                 }
             </p>`
                : ''
        }
        ${
            cctvTransferPersonalData?.cctvInternationalIsDisplay
                ? `<h4>
                ${
                    lang === 'TH'
                        ? cctvTransferPersonalData?.cctvInternationalTitleTh
                        : cctvTransferPersonalData?.cctvInternationalTitleEn
                }
            </h4>
            <p className="text-left">
                 ${
                     lang === 'TH'
                         ? cctvTransferPersonalData?.cctvInternationalContentTh ||
                           '-'
                         : cctvTransferPersonalData?.cctvInternationalContentEn ||
                           '-'
                 }
             </p>`
                : ''
        }
        ${
            cctvRetainPersonalData?.cctvRetentionIsDisplay
                ? `<h4>
                ${
                    lang === 'TH'
                        ? cctvRetainPersonalData?.cctvRetentionTitleTh
                        : cctvRetainPersonalData?.cctvRetentionTitleEn
                }
            </h4>
            <p className="text-left">
                 ${
                     lang === 'TH'
                         ? cctvRetainPersonalData?.cctvRetentionContentTh || '-'
                         : cctvRetainPersonalData?.cctvRetentionContentEn || '-'
                 }
             </p>`
                : ''
        }
        ${
            cctvRetainPersonalData?.cctvSecurityIsDisplay
                ? `<h4>
                ${
                    lang === 'TH'
                        ? cctvRetainPersonalData?.cctvSecurityTitleTh
                        : cctvRetainPersonalData?.cctvSecurityTitleEn
                }
            </h4>
            <p className="text-left">
                 ${
                     lang === 'TH'
                         ? cctvRetainPersonalData?.cctvSecurityContentTh || '-'
                         : cctvRetainPersonalData?.cctvSecurityContentEn || '-'
                 }
             </p>`
                : ''
        }
        ${
            cctvDataSubjectRight?.cctvDataSubjectRightIsDisplay
                ? `<h4>
                ${
                    lang === 'TH'
                        ? cctvDataSubjectRight?.cctvDataSubjectRightTitleTh
                        : cctvDataSubjectRight?.cctvDataSubjectRightTitleEn
                }
            </h4>
            <p className="text-left">
                 ${
                     lang === 'TH'
                         ? cctvDataSubjectRight?.cctvDataSubjectRightContentTh ||
                           '-'
                         : cctvDataSubjectRight?.cctvDataSubjectRightContentEn ||
                           '-'
                 }
             </p>`
                : ''
        }
        ${
            cctvPolicyChange?.cctvChangeIsDisplay
                ? `<h4>
                ${
                    lang === 'TH'
                        ? cctvPolicyChange?.cctvChangeTitleTh
                        : cctvPolicyChange?.cctvChangeTitleEn
                }
            </h4>
            <p className="text-left">
                 ${
                     lang === 'TH'
                         ? cctvPolicyChange?.cctvChangeContentTh || '-'
                         : cctvPolicyChange?.cctvChangeContentEn || '-'
                 }
             </p>`
                : ''
        }
        ${
            cctvPolicyChange?.cctvDataControllerIsDisplay
                ? `<h4>
                ${
                    lang === 'TH'
                        ? cctvPolicyChange?.cctvDataControllerTitleTh
                        : cctvPolicyChange?.cctvDataControllerTitleEn
                }
            </h4>
            <p className="text-left">
                 ${
                     lang === 'TH'
                         ? cctvPolicyChange?.cctvDataControllerContentTh || '-'
                         : cctvPolicyChange?.cctvDataControllerContentEn || '-'
                 }
             </p>`
                : ''
        }
        ${
            cctvPolicyChange?.cctvDataProtectionIsDisplay
                ? `<h4>
                ${
                    lang === 'TH'
                        ? cctvPolicyChange?.cctvDataProtectionTitleTh
                        : cctvPolicyChange?.cctvDataProtectionTitleEn
                }
            </h4>
            <p className="text-left">
                 ${
                     lang === 'TH'
                         ? cctvPolicyChange?.cctvDataProtectionContentTh || '-'
                         : cctvPolicyChange?.cctvDataProtectionContentEn || '-'
                 }
             </p>`
                : ''
        }
        <h4>${lang === 'TH' ? 'ฉบับ ณ วันที่' : 'Edition as of'}&nbsp;&nbsp;
                ${
                    effectiveDate
                        ? lang === 'TH'
                            ? DateTime.fromISO(effectiveDate, {
                                  locale: 'th',
                              }).toLocaleString(DateTime.DATE_FULL)
                            : DateTime.fromISO(effectiveDate, {
                                  locale: 'en',
                              }).toLocaleString(DateTime.DATE_FULL)
                        : '-'
                }</h4>
        <script type="text/javascript">
                $(document).ready(function() {
                let allElements = $('*');
                let converted = htmlDocx.asBlob(allElements.html());
                saveAs(converted, '${
                    lang === 'TH'
                        ? cctvPolicy?.cctvPolicyNameTh + `${date}TH.docx`
                        : cctvPolicy?.cctvPolicyNameEn + `${date}EN.docx`
                }');
                setTimeout(()=> window.close(), 100)
                });
        </script>
            </body>
    `;

    return {
        html: `
        <html>
        <head>
            <meta charset="UTF-8" />
            <title>Document</title>
            <script type="text/javascript" src="https://ajax.googleapis.com/ajax/libs/jquery/1.6.2/jquery.min.js"></script>
            <script src="https://cdnjs.cloudflare.com/ajax/libs/FileSaver.js/2.0.5/FileSaver.min.js"></script>
            <script src="https://evidenceprime.github.io/html-docx-js/build/html-docx.js"></script>
        </head>
            ${body}
        </html>`,
        body,
    };
}
